import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import ru from './locales/ru.json'
import fr from './locales/fr.json'
import de from './locales/de.json'
import es from './locales/es.json'
import it from './locales/it.json'
import hy from './locales/hy.json'
import hi from './locales/hi.json'
import bn from './locales/bn.json'
import { readNativeLanguageStringPreference } from './composables/usePreferencesStorage';

const supportedLocales = ['en', 'ru', 'fr', 'de', 'es', 'it', 'hy', 'hi', 'bn'] as const;
type SupportedLocale = typeof supportedLocales[number];

function isSupportedLocale(value: unknown): value is SupportedLocale {
	if (typeof value !== 'string') return false;
	return (supportedLocales as readonly string[]).includes(value);
}

function getInitialLocale(): SupportedLocale {
	try {
		const nativeLanguage = readNativeLanguageStringPreference();
		if (isSupportedLocale(nativeLanguage)) {
			return nativeLanguage;
		}

		return 'en';
	} catch {
		return 'en';
	}
}

const i18n = createI18n({
    legacy: false, // you must set `false`, to use Composition API
    locale: getInitialLocale(), // set locale
    fallbackLocale: 'en', // set fallback locale
    messages: {
        en,
        ru,
        fr,
        de,
        es,
        it,
        hy,
        hi,
        bn
    }
})

export default i18n
